import ReserveListTable from './ReserveListTable.vue'

export { ReserveListTable }
